<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-2"
        v-on="on"
        v-if="admin"
        tile
        outlined
        color="primary"
        @click="$emit('delete')"
      >
        <v-icon left>delete</v-icon>
        {{$t('DeviceTypes.delete')}}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title grey lighten-2" primary-title>{{$t('DeviceTypes.Dialog.delete')}}</v-card-title>
      <v-card-text class="mt-5">{{$t('DeviceTypes.Dialog.description-delete')}}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('DeviceTypes.back')}}</v-btn>
        <v-btn color="primary" text @click="deleteDeviceType">{{$t('DeviceTypes.sure')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
      admin: Boolean
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods:{
      deleteDeviceType: function(){
          this.dialog = false;
          this.$emit('deletedeviceType');
      }
  }
  
};
</script>